module.exports = __webpack_public_path__ + "vyhlazeni-vrasek-metodou-derma-k_18_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/vyhlazeni-vrasek-metodou-derma-k_18_before.jpg
// module id = 1246
// module chunks = 0